module.exports = __webpack_public_path__ + "img/wx_code.5cf9ec62.png";